import * as React from 'react';
import { cn } from '@/lib/utils';
import type { CategoryLabel } from '@/types/api';

export interface CategoryBadgeProps {
  category: CategoryLabel | string;
  className?: string;
}

const categoryStyles: Record<CategoryLabel, string> = {
  tutorial: 'bg-primary/10 text-primary',
  quick_tip: 'bg-tertiary/10 text-tertiary',
  concept: 'bg-secondary/10 text-secondary',
  tool_review: 'bg-tertiary/10 text-tertiary',
  strategy: 'bg-secondary/10 text-secondary',
  news: 'bg-error/10 text-error',
  personal_note: 'bg-tertiary/10 text-tertiary',
  task_dump: 'bg-warning/10 text-warning',
  resource: 'bg-secondary/10 text-secondary',
  unknown: 'bg-surface-container text-on-surface-variant',
};

const categoryLabels: Record<CategoryLabel, string> = {
  tutorial: 'Tutorial',
  quick_tip: 'Quick Tip',
  concept: 'Concept',
  tool_review: 'Tool Review',
  strategy: 'Strategy',
  news: 'News',
  personal_note: 'Personal Note',
  task_dump: 'Task Dump',
  resource: 'Resource',
  unknown: 'Unknown',
};

export const CategoryBadge = React.forwardRef<HTMLSpanElement, CategoryBadgeProps>(
  ({ category, className }, ref) => {
    const label = categoryLabels[category as CategoryLabel] || String(category || 'unknown').replace(/_/g, ' ');
    const style = categoryStyles[category as CategoryLabel] || 'bg-secondary/10 text-secondary';

    return (
      <span
        ref={ref}
        className={cn(
          'text-[10px] px-2 py-0.5 font-bold rounded-full uppercase',
          style,
          className
        )}
        aria-label={`Category: ${label}`}
      >
        {label}
      </span>
    );
  }
);

CategoryBadge.displayName = 'CategoryBadge';
